import { Tooltip } from "@mantine/core";
import type { ReactNode } from "react";

interface AppTooltipProps {
  label?: string;
  children: ReactNode;
}

const AppTooltip = ({ label, children }: AppTooltipProps) => {
  if (!label) {
    return children;
  }

  return <Tooltip label={label}>{children}</Tooltip>;
};

export default AppTooltip;
